import React from 'react';
import { TableItem } from '..';
import { DownloadIcon } from '../../../../assets/icons';


const Card: React.FC<{ data: TableItem; menu: React.ReactNode; index: number, CustomerCard: boolean, expenseCard: boolean | undefined; invoiceCard: boolean | undefined, inventoryCard: boolean | undefined, paymentHistoryCard:boolean | undefined }> = ({ data, menu, index, CustomerCard, expenseCard, invoiceCard, inventoryCard, paymentHistoryCard }) => {
  const isEven = index % 2 === 0;
  
  
  console.log(data)
  return (
    <>
    {CustomerCard && 
    <> 
    <div className={`max-w-md mx-auto bg-white rounded-sm shadow-md overflow-hidden md:max-w-2xl m-3 w-[350px] h-[126px] ${isEven ? 'bg-[#FFFFFF]' : 'bg-[#E6EDF5]'}`}>
      <div className='flex flex-row gap-[100px] justify-between'>
         <div className='flex flex-col pl-[16px] pt-[16px]'>
         <h2 className="text-violet-800 text-[15px] font-semibold mb-[8px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.customer}</h2>
         <span className="text-black text-[11px] font-normal mb-[30px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.email}</span>
         <span className="text-[11px] font-sm font-normal mb-[30px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.createdAt}</span>
         </div>

        <div className="flex flex-col gap-10 pr-[16px] pt-[15px]">
         <div className="">
         {menu}
         </div>
        <span className="text-[15px] flex font-sm font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.billed}</span>
        </div>
       </div>   

      </div>
    </> 
     }
    
    {invoiceCard &&
    <div className={`max-w-md mx-auto bg-white rounded-sm shadow-md overflow-hidden md:max-w-2xl m-3 w-[350px] h-[116px] ${isEven ? 'bg-[#FFFFFF]' : 'bg-[#E6EDF5]'}`}>
      <div className='flex flex-row gap-[100px] justify-between'>
         <div className='flex flex-col pl-[16px] pt-[16px]'>
         <h2 className=" text-[15px] font-semibold mb-[8px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.customer} </h2>
         <div className='flex flex-row gap-[8px] items-center'>
          <span className="text-violet-800 text-[11px] font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.invoiceNumber}</span>
         <span className="text-[14px] font-sm font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.issueDate}</span>
         </div>

         <div className='flex flex-row gap-[16px] items-center pt-[20px]'>
         <span className="text-[12px] font-sm font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.isReoccurring}</span>
         <span className="text-gray-500 text-[10px] font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.status}</span>
         </div>
         
         </div>

        <div className="flex flex-col gap-10 pr-[16px] pt-[15px]">
         <div className="">
         <span className=''>
          {menu}
         </span>
         </div>
        <span className="text-[15px] flex font-sm font-normal ml-[-3em]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.inventories}</span>
        </div>
       </div>   

      </div>
    
    }
    

  
 

  {
    expenseCard && 
    <div className={`max-w-md mx-auto bg-white rounded-sm shadow-md overflow-hidden md:max-w-2xl m-3 w-[350px] h-[116px] ${isEven ? 'bg-[#FFFFFF]' : 'bg-[#E6EDF5]'}`}>
      <div className='flex flex-row gap-[100px] justify-between'>
         <div className='flex flex-col pl-[16px] pt-[16px]'>
         <h2 className="text-black text-[15px] font-semibold mb-[8px]">{data.vendor || data.name} </h2>
         <span className="text-black text-[11px] font-normal mb-[20px]">{data.email || data.quantity}</span>
         <span className=" text-[11px] text-[#6A32C6] font-normal mb-[12px]">{data.createdAt}</span>
         <span className="text-[14px] font-sm font-normal">{data.category || data.rate}</span>
         </div>

        <div className="flex flex-col gap-10 pr-[16px] pt-[15px]">
         <div className="">
         <span className=''>
          {menu}
         </span>
         </div>
        <span className="text-[15px] flex font-sm font-normal">{data.amount}</span>
        </div>
       </div>   

      </div>
  }

{paymentHistoryCard && 
    <> 
    <div className={`max-w-md mx-auto bg-white rounded-sm shadow-md overflow-hidden md:max-w-2xl w-[360px] 412:w-[380px] 375:w-[340px] 414:w-[380px] 360:w-[320px] 540:w-[980px] h-[126px] ${isEven ? 'bg-[#FFFFFF]' : 'bg-[#E6EDF5]'}`}>
      <div className='flex flex-row justify-between'>

         <div className='flex flex-col pl-[16px] pt-[16px]'>
         <h2 className=" text-[15px] text-black font-semibold mt-[1em]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.amount}</h2>
         <span className="text-black text-[11px] font-normal mt-[1em] " style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.date}</span>
         <span className="text-[11px] font-semibold mt-[1em] text-black" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.method ? data.method: "N/A"}</span>
         </div>

        <div className="flex flex-col gap-10 pr-[60px] pt-[15px]">
        <span className="font-sm font-semibold" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}><p className=" pl-2 py-[4px] w-[80px] rounded-[4px] ">
          <a className="flex text-[#0500F9] text-[16px]" href="#payment-proof">
            Whatsa...PDF
            <DownloadIcon />
          </a>
        </p>
        </span>
        </div>

       </div>   

      </div>
    </> 
     }
    
      
    {inventoryCard &&
    <div className={`max-w-md mx-auto bg-white rounded-sm shadow-md overflow-hidden md:max-w-2xl m-3 w-[350px] h-[116px] ${isEven ? 'bg-[#FFFFFF]' : 'bg-[#E6EDF5]'}`}>
      <div className='flex flex-row gap-[100px] justify-between'>
         <div className='flex flex-col pl-[16px] pt-[16px]'>
         <h2 className=" text-[15px] font-semibold mb-[8px]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.customer} </h2>
         <div className='flex flex-row gap-[8px] items-center'>
          <span className="text-violet-800 text-[11px] font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.invoiceNumber}</span>
         <span className="text-[14px] font-sm font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.issueDate}</span>
         </div>

         <div className='flex flex-row gap-[16px] items-center pt-[20px]'>
         <span className="text-[12px] font-sm font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.isReoccurring}</span>
         <span className="text-gray-500 text-[10px] font-normal" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.status}</span>
         </div>
         
         </div>

        <div className="flex flex-col gap-10 pr-[16px] pt-[15px]">
         <div className="">
         <span className=''>
          {menu}
         </span>
         </div>
        <span className="text-[15px] flex font-sm font-normal ml-[-3em]" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>{data.inventories}</span>
        </div>
       </div>   

      </div>
    
    }
    
    </>
    
  );
};

export default Card;
